import React from 'react';
import './EssayQuestion.scss';
import type { EssayQuestion as EssayQuestionType } from '@/Data/Topik/types';

interface EssayQuestionProps {
    question: EssayQuestionType;
    value: string;
    onChange: (questionId: number, value: string) => void;
}

export const EssayQuestion: React.FC<EssayQuestionProps> = ({ 
    question, 
    value, 
    onChange 
}) => {
    return (
        <div className="EssayAnswer">
            <textarea
                className="EssayTextarea"
                value={value}
                onChange={(e) => onChange(question.questionid, e.target.value)}
                placeholder="답을 작성해주세요."
                rows={8}
            />
            {question.word_limit && (
                <div className="WordLimit">
                    {value.length} / {question.word_limit.max} {"자"}
                </div>
            )}
        </div>
    );
};